jQuery(document).ready(function($) {
    $(".add-cart-custom").click(function(){
        $(".shopify-product-form .add_to_cart").trigger("click");
    });

    $(".buy-now-custom").click(function(){
        $(".shopify-product-form").trigger('submit');    
    });

    // $(".shopify-product-form").trigger('submit');    
    //buy-now-custom
});